<!-- One job per route: /generate runs the template, /edit and /new change it. The page ends with one
     right-aligned button group; a disabled button takes no pointer events, so its wrapper carries the reason. -->
<section class="workspace-page workspace-page--full workspace-page__panel--card">
  <header class="workspace-page__heading">
    <div><h2 class="workspace-page__title">{{ title }}</h2>
      <span *ngIf="template && !isNew" class="br-text-muted">{{ template.isSystem ? 'System template' : 'Company template' }} · {{ template.isActive ? 'Active' : 'Archived' }}</span></div>
  </header>
  <div class="workspace-page__body br-p-3">
    <p *ngIf="loading" role="status">Loading template…</p>
    <div *ngIf="error" class="br-alert br-alert--danger" role="alert">{{ error }}</div>
    <ng-container *ngIf="!loading && (template || isNew)">
      <ng-container *ngIf="editing; else generateForm">
        <p *ngIf="template?.isSystem && isNew" class="br-small br-text-muted" role="status">
          Saving creates a company copy. The system template stays unchanged.</p>
        <label class="br-form-label" for="template-name">Name</label>
        <input id="template-name" class="br-form-control" maxlength="160" [readonly]="saving" [(ngModel)]="form.name">
        <label class="br-form-label br-mt-3" for="template-description">Description</label>
        <input id="template-description" class="br-form-control" maxlength="1000" [readonly]="saving" [(ngModel)]="form.description">
        <label class="br-form-label br-mt-3" for="template-instructions">Instruction</label>
        <textarea id="template-instructions" class="br-form-control" rows="14" [readonly]="saving" [(ngModel)]="form.instructions"
                  placeholder="What data to read, which analyses to run, which charts or tables to draw, and which conclusions to give."></textarea>
      </ng-container>
      <ng-template #generateForm>
        <p *ngIf="template?.description" class="br-mb-3">{{ template?.description }}</p>
        <div class="br-flex br-flex-wrap br-gap-3">
          <label class="br-form-label br-mb-0">Interval
            <select class="br-form-select br-w-auto" [ngModel]="interval" (ngModelChange)="changeInterval($event)">
              <option *ngFor="let option of intervals" [ngValue]="option.code">{{ option.label }}</option>
            </select>
          </label>
          <label *ngIf="periods.length" class="br-form-label br-mb-0">Period
            <select class="br-form-select br-w-auto" [ngModel]="period || target?.periodStart" (ngModelChange)="changePeriod($event)">
              <option *ngFor="let option of periods" [ngValue]="option.periodStart">{{ periodLabel(option) }}</option>
            </select>
          </label>
        </div>
        <p class="br-small br-mt-2 br-mb-0" role="status">
          <ng-container *ngIf="targetLoading">Finding the period…</ng-container>
          <ng-container *ngIf="target">Bree will analyze <strong>{{ targetLabel }}</strong>.</ng-container>
          <span *ngIf="targetError" class="br-text-danger">{{ targetError }} <button type="button" class="br-btn br-btn--sm" (click)="loadTarget()">Retry</button></span>
        </p>
        <label class="br-form-label br-mt-3" for="report-focus">Focus for this report <span class="br-text-muted">(optional)</span></label>
        <textarea id="report-focus" class="br-form-control" rows="2" maxlength="1000" [(ngModel)]="focus"
                  placeholder="For example: explain the slower collections"></textarea>
        <details class="br-mt-3">
          <summary class="br-small br-text-muted">Template instruction</summary>
          <p class="template-instruction br-mt-2 br-mb-0">{{ template?.instructions }}</p>
        </details>
      </ng-template>
    </ng-container>
  </div>
  <footer class="workspace-page__footer br-justify-end">
    <button type="button" class="br-btn br-btn--outline-secondary br-btn--sm" [disabled]="saving" (click)="back()">Cancel</button>
    <ng-container *ngIf="editing; else generateAction">
      <button *ngIf="template && !isNew && !template.isSystem" type="button" class="br-btn br-btn--outline-secondary br-btn--sm"
              [disabled]="saving" (click)="setArchived(template.isActive)">
        <br-icon>{{ template.isActive ? 'archive' : 'unarchive' }}</br-icon> {{ template.isActive ? 'Archive' : 'Restore' }}
      </button>
      <button type="button" class="br-btn br-btn--primary br-btn--sm" [disabled]="saving || !form.name.trim() || !form.instructions.trim()" (click)="save()">Save</button>
    </ng-container>
    <ng-template #generateAction>
      <span *ngIf="template" [matTooltip]="generateBlockedReason" [matTooltipDisabled]="!generateBlockedReason">
        <button type="button" class="br-btn br-btn--primary br-btn--sm" [disabled]="!canGenerate" (click)="generate()">Generate report</button>
      </span>
    </ng-template>
  </footer>
</section>